import styled from 'styled-components';

export const CHARTS_COLORS = {
    ashore: '#661887',
    completed: '#409bdb',
};

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 10px 10px;
    padding: var(--spacing-md, 24px);
    background-color: var(--colors-surface-primary, #fff);
    border-radius: 10px;
    border: 1px solid var(--colors-border-primary, #e2e8f0);
`;

// Left Column
export const LeftPart = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    height: 258px;
    justify-content: space-between;
    margin-right: 3rem;
`;

export const TopPart = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs, 8px);
    width: 100%;
`;

// Bottom Column
export const BottomPart = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 24px);
    width: 100%;
`;

export const ProgressBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm, 16px);
    width: 100%;
`;

export const Completed = styled.div`
    display: flex;
    align-items: baseline;
    gap: var(--spacing-xs, 8px);
`;

export const CompletedValue = styled.span`
    font-family: 'Poppins', Helvetica, serif;
    color: var(--colors-text-body, #50566e);
    font-size: var(--fontsize-heading-sm, 24px);
    font-weight: 600;
    line-height: var(--line-height-heading-sm, 32px);
`;

export const CompletedLabel = styled.span`
    font-family: 'Poppins', Helvetica, serif;
    color: var(--colors-text-body, #50566e);
    font-size: var(--fontsize-body-xs, 12px);
    font-weight: 400;
    line-height: var(--line-height-body-xs, 16px);
`;

export const StatWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

export const ProgressText = styled.div`
    text-align: right;
    font-family: 'Poppins', Helvetica, serif;
    color: var(--colors-text-body, #50566e);
    font-size: var(--fontsize-body-xs, 12px);
    font-weight: 400;
    line-height: var(--line-height-body-xs, 16px);
`;

export const WeekMonth = styled.div`
    display: flex;
    gap: var(--spacing-xs);
`;

export const StatBox = styled.div`
    flex: 1;
    padding: 10px;
    background-color: var(--primary-100);
    border: 1px solid var(--primary-300);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StatValue = styled.div`
    font-family: 'Poppins', Helvetica, serif;
    color: var(--colors-icons-information, #2171c6);
    font-size: var(--fontsize-body-md, 16px);
    font-weight: 500;
    line-height: var(--line-height-body-md, 24px);
`;

export const StatLabel = styled.div`
    font-family: 'Poppins', Helvetica, serif;
    font-size: var(--body-xs-xs, 0.75rem);
    color: var(--colors-text-on-disabled, #70768d);
`;

// Right Column
export const RightPart = styled.div`
    display: flex;
    flex-direction: column;
    width: 30%;
    justify-content: space-between;
`;

export const Subtitle = styled.div`
    font-family: 'Poppins', Helvetica, serif;
    font-size: var(--body-xs-xs, 0.75rem);
    color: var(--colors-text-body, #50566e);
    margin-bottom: var(--spacing-md, 8px);
    padding-left: 2rem;
    align-self: center;
`;

export const Graph = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Legend = styled.div`
    display: flex;
    gap: var(--spacing-xs, 8px);
    align-items: center;
    margin-top: 10px;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
`;

export const LegendColor = styled.div<{ $color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 2px;
    background: ${(props) => props.$color};
`;

export const LegendLabel = styled.div`
    font-family: 'Poppins', Helvetica, serif;
    font-size: var(--body-xs-xs, 0.75rem);
    color: var(--colors-text-on-disabled, #70768d);
`;
